import React from 'react';
import { Icon } from '../icon/icon.react-component';
/** Do not use this directly.  This function is used by the Webpack `.ud-icon` loader
 * @deprecated Please use the `Icons` component from `@udemy/icons` instead.
 *
 * @param glyph string to use to render the correct SVG symbol definition
 * @returns Icon React component
 */

export function createIcon(glyph) {
  const icon = _ref => {
    let { ...props
    } = _ref;
    return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
      glyph: glyph
    }));
  };

  icon.displayName = 'UDIconFile';
  icon.$$udType = 'UDIconFile';
  return icon;
}
//# sourceMappingURL=create-icon.js.map